import React from 'react';
import {Col, Form, Modal} from 'react-bootstrap';
import {detectSource} from "../utils/sourceDetection";


const ManualPostalAddress = (props) => {
  const source = detectSource();
  const isVTNZPath = source === 'VTNZ';
  const isAAPath = source === 'AA' || source === 'AA_MEMBER';

    const buttonStyle = {
      backgroundColor: isVTNZPath ? '#E87722' : isAAPath ? '#0d59bf' : '#0073CF',
      color: "white",
        paddingLeft: 25,
        paddingRight: 25,
        paddingTop: 13,
        paddingBottom: 13,
        width:"100%",
        maxWidth:"200px",
        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
      borderRadius: isAAPath || isVTNZPath ? 30 : 6,
        overflow: 'hidden',
      border: isAAPath ? '1px #0d59bf solid' : isVTNZPath ? '1px #E87722 solid' : '1px #1851a3 solid',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'inline-flex',
        cursor:  'pointer',
        opacity:  1
    };

    const handleClose = () => {

        if (!props.inputValues.addressLine1 || props.inputValues.addressLine1 === '') props.errors.addressLine1 = 'Is mandatory'


        if (!props.inputValues.suburb || props.inputValues.suburb === '') props.errors.suburb = 'Is mandatory'

        if (!props.inputValues.city || props.inputValues.city === '') props.errors.city = 'Is mandatory'

        if (!props.inputValues.postcode || props.inputValues.postcode === '') props.errors.postcode = 'Is mandatory'

        let fullAddress = props.inputValues.addressLine1;
        if(props.inputValues.addressLine2 !== '') {
            fullAddress += ', '+ props.inputValues.addressLine2;
        }
        fullAddress += ', '+props.inputValues.suburb + ', '+props.inputValues.city + ', '+props.inputValues.postcode
        props.handleChangeValue('full_address', fullAddress);
        props.setParentManualAddressPopupShow(false);
    };

    const close = () => {
        props.setParentManualAddressPopupShow(false);
    };

    return (
        <>
            <Modal
                show={props.parentManualAddressPopupShow}
                onHide={close}

                backdrop="static"
                size="lg"
                keyboard={false}
            >
                <Modal.Header closeButton>
                  <Modal.Title className="subHeadingStyles"
                               style={{color: isAAPath ? '#0d59bf' : isVTNZPath ? '#E87722' : '#0073CF'}}>Enter
                    Address Manually</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row boldTextStyles">
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label className='formHeader'>Address Line 1</Form.Label>
                            <Form.Control required type="search" id='address_line_1'
                                name='addressLine1'
                                value={props.inputValues.addressLine1}
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.addressLine1}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.addressLine1}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4">
                            <Form.Label>Address Line 2</Form.Label>
                            <Form.Control
                                name="addressLine2"
                                value={props.inputValues.addressLine2}
                                onChange={props.handleChange}
                            />
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label>Suburb</Form.Label>
                            <Form.Control required
                                name="suburb"
                                value={props.inputValues.suburb}
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.suburb}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.suburb}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label>City</Form.Label>
                            <Form.Control required
                                name="city"
                                value={props.inputValues.city}
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.city}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.city}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                        <Form.Group as={Col} md="4" className="form-group required">
                            <Form.Label>Postcode</Form.Label>
                            <Form.Control required
                                name="postcode"
                                value={props.inputValues.postcode}
                                onChange={props.handleChange}
                                isInvalid={!!props.errors.postcode}
                            />
                            <Form.Control.Feedback type="invalid">
                                {props.errors.postcode}
                            </Form.Control.Feedback>
                        </Form.Group><Col md="1" />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                  <button style={buttonStyle} onClick={handleClose}>
                        Use this address
                  </button>
                </Modal.Footer>
            </Modal>
        </>
    )

}

export default ManualPostalAddress;
